<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card
          inline
          color="primary"
          icon="mdi-barcode-scan"
          :title="`Visualização da Variação de Preço Unitário: ${nome}`"
          class="ml-0 px-5 py-4"
        >
          <v-tabs v-model="tab" class="my-10" background-color="grey lighten-3" color="white" grow slider-size="65">
            <v-tabs-slider class="mt-1" color="primary" />

            <v-tab :ripple="false">Gráficos</v-tab>
            <v-tab :ripple="false">Analítico</v-tab>
          </v-tabs>

          <!-- Filtragem -->
          <v-row align="center" justify="space-between" class="mx-auto" dense>
            <v-col cols="2" md="auto" align-self="start">
              <v-tooltip bottom :disabled="loading">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" icon x-large :disabled="loading" v-on="on" @click="ordemDecrescente = !ordemDecrescente">
                    <v-icon x-large>
                      {{ ordemDecrescente ? 'mdi-sort-variant' : 'mdi-sort-reverse-variant' }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ ordemDecrescente ? 'Ordernar por ordem crescente' : 'Ordernar por ordem decrescente' }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="10" md="3">
              <v-select v-model="filtros.variavel" :disabled="loading" outlined :items="variaveisDisponiveis" label="Variável" />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="filtros.tucs"
                :disabled="loading"
                small-chips
                deletable-chips
                multiple
                outlined
                clearable
                clear-icon="mdi-close-circle"
                :items="tucsDisponiveis"
                label="TUCs"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small tag="span">
                    {{ item }}
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">+{{ filtros.tucs.length - 1 }}</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="filtros.codMaterial"
                :disabled="loading"
                small-chips
                deletable-chips
                multiple
                outlined
                clearable
                clear-icon="mdi-close-circle"
                :items="codMaterialList"
                label="Cód. Material"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0" small tag="span">
                    {{ item.value }}
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">+{{ filtros.codMaterial.length - 1 }}</span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <charts-list-variacoes-preco-unitario v-show="tab === 0" :dados="filteredData" :loading="loading" />

          <analitico-variacoes-preco-unitario v-show="tab === 1" :dados="filteredData" :tucsDisponiveis="tucsAvailableFiltered" />
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import VariacoesPrecoUnitarioService from '@/services/VariacoesPrecoUnitarioService.js';

  export default {
    name: 'VisualizarVariacaoPrecoUnitario',

    components: {
      ChartsListVariacoesPrecoUnitario: () => import('@/components/variacoesPrecoUnitario/ChartsListVariacoesPrecoUnitario.vue'),
      AnaliticoVariacoesPrecoUnitario: () => import('@/components/variacoesPrecoUnitario/AnaliticoVariacoesPrecoUnitario.vue')
    },

    data() {
      return {
        nome: '',
        tab: 0,
        loading: true,
        tucsDisponiveis: [],
        variaveisDisponiveis: [],
        dados: [],
        filtros: {
          variavel: '',
          tucs: [],
          codMaterial: []
        },
        ordemDecrescente: true
      };
    },

    computed: {
      variavelSelecionada() {
        return this.filtros.variavel;
      },
      tucsAvailableFiltered() {
        let tucsAvailableFiltered = [];
        let tucs = [];

        tucsAvailableFiltered = this.filtros.tucs.length > 0 ? this.filtros.tucs : this.tucsDisponiveis;

        if (this.filtros.codMaterial.length > 0) {
          //monta uma variavel com o CodMaterial e tucs
          let codMaterial = this.dados.map((dado) => {
            return {
              cod: dado.CodMaterial,
              tuc: dado.TUC
            };
          });
          //compara o filtros.codMaterial com a variavel codMaterial, se for igual pega a tuc
          this.filtros.codMaterial.forEach((cod) => {
            tucs.push(codMaterial.filter((dado) => dado.cod.includes(cod))[0].tuc);
          });
          //remove valores repetidos
          tucsAvailableFiltered = [...new Set(tucs)];
        }

        return tucsAvailableFiltered;
      },
      filteredData() {
        if (!this.dados) return [];

        let filteredData = this.dados;

        // Filtro de TUCs
        if (this.filtros.tucs.length > 0) {
          filteredData = filteredData.filter((dado) => this.filtros.tucs.includes(dado.TUC));
        }
        // Filtro de Cod. Material
        if (this.filtros.codMaterial.length > 0) {
          filteredData = filteredData.filter((dado) => this.filtros.codMaterial.includes(dado.CodMaterial));
        }

        return filteredData;
      },
      codMaterialList() {
        if (!this.dados) return [];
        let codMaterial = this.dados.map((dado) => {
          return {
            text: `${dado.CodMaterial} - TUC ${dado.TUC}`,
            value: dado.CodMaterial
          };
        });

        if (this.filtros.tucs.length > 0) {
          let novoCodMaterial = codMaterial.filter((dado) => {
            let aux = false;

            this.filtros.tucs.forEach((item, key) => {
              if (dado.text.includes(`TUC ${this.filtros.tucs[key]}`) == true) aux = true;
            });

            return aux;
          });
          return novoCodMaterial;
        } else {
          return codMaterial;
        }
      }
    },

    mounted() {
      this.getDadosVariacao(this.$route.params.id);
    },

    methods: {
      getDadosVariacao(id) {
        return VariacoesPrecoUnitarioService.getItem(id)
          .then((res) => {
            const item = res.data.item;

            this.nome = item.nome;
            this.tucsDisponiveis = item.parametros.tucs;
            this.variaveisDisponiveis = item.parametros.vars;
            this.filtros.variavel = this.variaveisDisponiveis[0];
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao recuperar Variação de Preço Unitário.', '', { position: 'topRight' });
            this.$router.push({ name: 'Variações de Preço Unitário Histórico' });
          });
      },
      getDadosRelatorio(id) {
        this.dados = [];
        this.loading = true;
        const ordem = this.ordemDecrescente ? 'DESC' : 'ASC';

        VariacoesPrecoUnitarioService.getDadosRelatorio(id, this.variavelSelecionada, ordem)
          .then((res) => {
            this.dados = res.data.dados;
            this.loading = false;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao recuperar Variação de Preço Unitário.', '', { position: 'topRight' });
            this.$router.push({ name: 'Variações de Preço Unitário Histórico' });
          });
      }
    },

    watch: {
      variavelSelecionada(newValue) {
        if (newValue) {
          this.getDadosRelatorio(this.$route.params.id);
        }
      },
      ordemDecrescente() {
        this.getDadosRelatorio(this.$route.params.id);
      }
    }
  };
</script>

<style></style>

<style lang="sass">
  .v-tabs-bar
    height: 56px !important
    padding: 0 0px

  .v-tabs-slider-wrapper
    overflow: visible

  .v-tabs-slider
    border-radius: 4px

  .v-tabs-slider-wrapper
    contain: initial
    z-index: 0
</style>